<template>
    <div class="alarm-clock">
	<!--div class="date">
		<span class="month"></span>
		<span class="day"></span>,
		<span class="year"></span>
	</div-->

	<div class="time">
		<span class="hours"></span>
		<span class="colon">:</span>
		<span class="minutes"></span>
		<span class="colon">:</span>
		<span class="seconds"></span>
	</div>
</div>
</template>

<script>
export default {
    name: 'clock',
    data() {
        return {
            hours: document.querySelector('.hours'),
            minutes: document.querySelector('.minutes'),
            seconds: document.querySelector('.seconds'),
            month: document.querySelector('.month'),
            day: document.querySelector('.day'),
            year: document.querySelector('.year'),
        };
    },
    mounted() {
        setInterval(this.setDate,1000);
        this.$data.hours = document.querySelector('.hours');
        this.$data.minutes = document.querySelector('.minutes');
        this.$data.seconds = document.querySelector('.seconds');
        this.$data.month = document.querySelector('.month');
        this.$data.day = document.querySelector('.day');
        this.$data.year = document.querySelector('.year');
    },
    methods: {
        setDate() {
            const now = new Date();
            const mm = now.getMonth();
            const dd = now.getDate();
            const yyyy = now.getFullYear();
            const secs = now.getSeconds();
            const mins = now.getMinutes();
            const hrs = now.getHours();
            const monthName = [
                'January','February','March','April',
                'May','June','July','August','September',
                'October','November','December'
            ];
            
            if (hrs > 24) {
                this.$data.hours.innerHTML = hrs - 24;
            } else {
                this.$data.hours.innerHTML = hrs;
            }
            
            if (secs < 10) {
                this.$data.seconds.innerHTML = '0' + secs;
            } else {
                this.$data.seconds.innerHTML = secs;
            }
            
            if (mins < 10) {
                this.$data.minutes.innerHTML = '0' + mins;
            } else {
                this.$data.minutes.innerHTML = mins;
            }
            
           // this.$data.month.innerHTML = monthName[mm];
           // this.$data.day.innerHTML = dd;
           // this.$data.year.innerHTML = yyyy;
        }
    }
};
</script>

<style lang="scss" scoped>
    $base-duration: 500ms;

    // Colors
    $color-1: slategray;
    $color-2: #3498db;
    $color-3: #8C30DA;

    // Breakpoints
    $sm: new-breakpoint(min-width 320px);
    $med: new-breakpoint(min-width 768px);
    $lg: new-breakpoint(min-width 1024px);

    *, *:before, *:after {
        box-sizing: border-box;
        outline: none;
    }

   
    .alarm-clock {
        position: relative;
        border-radius: 10px;
        display: flex;
        margin-left: 3rem;        
        .date {
            position: absolute;
            bottom: 15px;
            left: 50%;
            color: white;
            font-size: 12px;
            text-transform: uppercase;
            transform: translateX(-50%);
            z-index: 9;
        }
        
        .time {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
         //  background-color: #333;
            border-radius: 10px;

            font-family: 'Orbitron', sans-serif;
            //font-family: 'Menlo', monospace;
            font-size: 25px;

            span {
                position: relative;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                //width: 85px;
                color: $color-3;
                color: linear-gradient(to right, #8C30DA 260px, #5C48D4);
                text-shadow: 0 0 15px rgba($color-3,0.4);
                line-height: 1.75;

                // background-color: white;
                // border: 1px solid red;

                &:nth-of-type(5) {
                    // width: 90px;
                }

                &.colon {
                    width: 12px;
                    text-align: center;
                   // animation: blink 2s infinite;
                }
            }
        }
    }



    @keyframes blink {
        0%   { opacity: 0; }
        30%  { opacity: 1; }
        50%  { opacity: 0; }
        70%  { opacity: 1; }
        100% { opacity: 0; }
    }
</style>